import { lcLessonPhotosApi, type LessonPhoto } from '@/api/lcLessonPhotos'

export const MAX_PHOTO_BYTES = 10 * 1024 * 1024
const MIME_BY_EXTENSION: Record<string, string> = { jpg: 'image/jpeg', jpeg: 'image/jpeg', png: 'image/png', webp: 'image/webp', heic: 'image/heic', heif: 'image/heif' }
export const PHOTO_ACCEPT = Object.values(MIME_BY_EXTENSION).join(',')
export function photoContentType(file: File): string | null {
  if (file.type) return Object.values(MIME_BY_EXTENSION).includes(file.type.toLowerCase()) ? file.type.toLowerCase() : null
  return MIME_BY_EXTENSION[file.name.split('.').pop()?.toLowerCase() ?? ''] ?? null
}
export class PhotoValidationError extends Error {
  constructor(public code: 'FILE_TOO_LARGE' | 'UNSUPPORTED_CONTENT_TYPE' | 'PHOTO_LIMIT_EXCEEDED') { super(code) }
}
export interface FailedPhoto { file: File; error: unknown }
export async function uploadLessonPhotos({ learnerId, lessonId, attemptId, componentKey = null, files, remaining, onSaved }: {
  learnerId: number; lessonId: number; attemptId: number | null; componentKey?: string | null; files: File[]; remaining: number; onSaved: (photo: LessonPhoto) => void
}): Promise<FailedPhoto[]> {
  const failed: FailedPhoto[] = []
  for (const [index, file] of files.entries()) {
    try {
      if (index >= remaining) throw new PhotoValidationError('PHOTO_LIMIT_EXCEEDED')
      if (file.size > MAX_PHOTO_BYTES) throw new PhotoValidationError('FILE_TOO_LARGE')
      const contentType = photoContentType(file)
      if (!contentType) throw new PhotoValidationError('UNSUPPORTED_CONTENT_TYPE')
      const urls = await lcLessonPhotosApi.uploadUrl(learnerId, lessonId, attemptId, contentType, componentKey)
      await lcLessonPhotosApi.put(urls.uploadUrl, file, contentType)
      onSaved(await lcLessonPhotosApi.confirm(learnerId, lessonId, attemptId, urls.fileUrl, componentKey))
    } catch (error) { failed.push({ file, error }) }
  }
  return failed
}
export function formatPhotoTime(value: string, language: string): string {
  return new Intl.DateTimeFormat(language.startsWith('en') ? 'en-US' : 'ko-KR', {
    timeZone: 'Asia/Seoul', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit',
  }).format(new Date(value))
}
